<!-- <app-sub-header [title]="'Ambulance'"></app-sub-header> -->

<div class="content">
  <div class="form-cont">
    <div class="row">
      <div class="col-xl-3 col-lg-4 col-md-5">
        <app-stickybar></app-stickybar>
      </div>

      <div class="col-xl-9 col-lg-8 col-md-7">
        <div class="card patient-details-card" style="min-height: 955px">
          <div class="card-body pt-0">
            <div class="tab-content pt-0">
              <div id="pat_medicalrecords" class="tab-pane fade show active">
                <div class="tabs-container">
                  <h1>Ambulance Bookings</h1>
                  <a
                    class="add-new-btn button_class"
                    [class.disabled]="tableData.length === 1"
                    (click)="checkEligibility()"
                  >
                    Book Ambulance
                  </a>
                </div>

                <div
                  class="card card-table mb-0 booking-details"
                  style="
                    min-height: auto !important;
                    background-color: #edf5fb !important;
                  "
                >
                  <div class="card-body">
                    <app-ag-grid-table
                      [subTitle]="'Booking Details'"
                      #agGridRef
                      [rowData]="rowData"
                      [parentContext]="this"
                      [columnDefs]="colDefs"
                      [paginationPageSize]="paginationPageSize"
                      (gridReady)="onGridReady($event)"
                      (reloadTable)="reload($event)"
                    ></app-ag-grid-table>
                  </div>
                </div>
                <app-history *ngIf="historyVisible"></app-history>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="apology-modal" *ngIf="showApology">
  <div class="apology-box">
    <img
      src="../../../../assets/img/check-mark-removebg-preview.png"
      alt="Success"
      class="success-icon"
    />
    <h2>Booking successful</h2>
    <p class="apology-text">Our Ambulance agent will contact you shortly!!</p>
    <button class="btn done button_class" (click)="this.showApology = false">
      Okay
    </button>
  </div>
</div>

<div class="custom-modal-backdrop" id="popupModal" *ngIf="showApologies">
  <div class="custom-modal">
    <button class="close-btn" (click)="showApologies = false">×</button>
    <h2>⏳ Hold On! You're Almost There</h2>
    <p>
      To unlock this service, you need to be with us for at least 3 months.<br />
      But good news! You don’t have to wait — enjoy this service now via
      A-la-carte for a small fee.
    </p>
    <p class="highlight">👉 Tap Continue to access it instantly.</p>
    <button class="continue-btn button_class" (click)="openForm()">
      Continue
    </button>
  </div>
</div>

<div class="no-plan-popup-backdrop" *ngIf="showNoPlanPopup">
  <div class="no-plan-popup-modal">
    <button class="no-plan-popup-close-btn" (click)="showNoPlanPopup = false">
      ×
    </button>
    <h2>🔒 No Plan? No Problem!</h2>
    <p>
      You're not subscribed to any plan, but you can still book this service via
      A-la-carte at a nominal cost.
    </p>
    <div class="no-plan-popup-button-group">
      <button
        class="no-plan-popup-action-btn button_class"
        (click)="openForm()"
      >
        Book via A-la-carte
      </button>
      <button
        class="no-plan-popup-action-btn button_class"
        (click)="upgradePlan()"
      >
        Subscription plans
      </button>
    </div>
  </div>
</div>

<div class="exclusive-popup-backdrop" *ngIf="showExclusivePopup">
  <div class="exclusive-popup-modal">
    <button
      class="exclusive-popup-close-btn"
      (click)="showExclusivePopup = false"
    >
      ×
    </button>
    <h2>🚫 Exclusive Service</h2>
    <p>This service is available under a premium plan.<br />You can:</p>
    <ul class="exclusive-popup-list">
      <li>⚡ Upgrade to a premium plan for full access</li>
      <li>💳 Use A-la-carte and pay only for this service</li>
    </ul>
    <div class="exclusive-popup-button-group">
      <button
        class="exclusive-popup-action-btn button_class"
        (click)="upgradePlan()"
      >
        Upgrade Plan
      </button>
      <button
        class="exclusive-popup-action-btn button_class"
        (click)="openForm()"
      >
        Use A-la-carte
      </button>
    </div>
  </div>
</div>

<div *ngIf="showDeleteModal" class="delete-dialog-backdrop">
  <div class="delete-dialog-box">
    <h3>Cancel Booking</h3>
    <p>Are you sure you want to cancel this booking?</p>
    <div class="delete-dialog-actions">
      <button class="btn-cancel" (click)="closeDeleteModal()">Cancel</button>
      <button class="btn-confirm" (click)="deleteBooking()">Confirm</button>
    </div>
  </div>
</div>
<a
  id="openAddTeleModal"
  class="d-none"
  data-bs-toggle="modal"
  data-bs-target="#book_amb"
></a>

<div class="no-plan-popup-backdrop" *ngIf="showRejectPopup">
  <div class="no-plan-popup-modal reject-modal">
    <img
      src="../../../../assets/img/ambulance/question-reason.webp"
      alt="Question"
      class="modal-question-icon"
    />
    <span class="reason-text">Reason for rejection</span>
    <div class="popup-content">
      <textarea class="reason-textarea" readonly>{{
        rejectReasonValue
      }}</textarea>
    </div>

    <button class="ok-btn" (click)="closeRejectReason()">Okay</button>
  </div>
</div>

<div class="assign-popup" *ngIf="popupService.showAssignPopup">
  <div class="assign-box">
    <p>
      🚑 Ambulance is not Assigned Yet. Please wait while your ambulance is
      being assigned
    </p>
    <button (click)="closeAssignPopup()">OK</button>
  </div>
</div>

<div class="assign-popup" *ngIf="popupService.showBlankDataPopup">
  <div class="assign-box">
    <p>Either Ambulance Tracker Id or User's Location Coordinate is Missing</p>
    <button (click)="closeBlankDataPopup()">OK</button>
  </div>
</div>

<ngx-spinner
  bdColor="rgba(51, 51, 51, 0.8)"
  size="medium"
  color="skyblue"
  type="ball-clip-rotate"
  [fullScreen]="true"
>
  <p class="spinner-text">Please wait...</p>
</ngx-spinner>
